import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';
import { setIsManuallyAddress, setRegistrationNameStep } from '@interlayer/js/app/store/reducers/Registration/actions';

import { REGISTRATION_ORDERED_OBJECT_STEPS, REGISTRATION_ORDERED_STEPS } from '../constants';
import { TRegistrationSteps } from '../types';

const useNextStep = () => {
    const { registrationNameStep } = useRegistrationSelector();

    return REGISTRATION_ORDERED_STEPS[REGISTRATION_ORDERED_OBJECT_STEPS[registrationNameStep as TRegistrationSteps] + 1];
};

const usePrevStep = () => {
    const { registrationNameStep } = useRegistrationSelector();

    return REGISTRATION_ORDERED_STEPS[REGISTRATION_ORDERED_OBJECT_STEPS[registrationNameStep as TRegistrationSteps] - 1];
};

export const useRegistrationPagination = () => {
    const dispatch = useDispatch();
    const nextStep = useNextStep();
    const prevStep = usePrevStep();
    const { isManuallyAddress } = useRegistrationSelector();

    const handlerNextStep = useCallback(() => {
        dispatch(setRegistrationNameStep(nextStep));
    }, [dispatch, nextStep]);

    const handlerPrevStep = useCallback(() => {
        if (isManuallyAddress) {
            dispatch(setIsManuallyAddress(false));
            return;
        }

        dispatch(setRegistrationNameStep(prevStep));
    }, [dispatch, isManuallyAddress, prevStep]);

    const handlerNavigateStep = useCallback((stepIndex) => {
        dispatch(setRegistrationNameStep(REGISTRATION_ORDERED_STEPS[stepIndex]));
    }, [dispatch]);

    return useMemo(() => ({
        handlerNextStep,
        handlerPrevStep,
        handlerNavigateStep
    }), [handlerNavigateStep, handlerNextStep, handlerPrevStep]);
};

